<template>
<div :style="fromPage !== 'listing' ? 'height:300px;overflow:auto;':''" @touchmove.stop="emptyFunc">
    <!--跨境关联商品-->
    <div v-if="relationItems.length" class=" paddingt30 paddingb10" style="padding-left: 12px;padding-right: 12px">
        <div class="fs-14 flex-container between">
            <span>产品</span>
            <div @click="imgStyle = !imgStyle">
                <div v-show="imgStyle">
                    <img src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-list.png"
                         alt="" width="16" style="margin-right: 4px;vertical-align: sub;">列表
                </div>
                <div v-show="!imgStyle">
                    <img src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-big-pic.png"
                         alt="" width="16" style="margin-right: 4px;vertical-align: sub;">大图
                </div>
            </div>
        </div>
        <div class="row container margint30 scroll-container" style="padding: 0" v-show="relationItems.length > 4 && imgStyle">
            <div v-for="item in relationItems.slice(0, Math.ceil(relationItems.length / 2))" @click="changeProduct(item)"
                 class="badge dis-i pos-r badge-img"
                 :class="[chooseId === item.itemId ? 'active' : '']"
                 style="min-width:20%;width: 100px;vertical-align: top;margin: 0 4px 12px">
                <img class="img-sku" :src="item.imageUrl" alt="" width="100">
                <img @click.stop="relationImgClick(item.imageUrl)"
                     src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-img-click.png"
                     width="20" class="pos-a left0 top0" alt="">
                <span class="dis-b paddingv10 fs-14 text-limit3"
                      style="line-height: 20px;margin: 4px 6px;min-height: 24px" v-text="item.shortName"></span>
            </div>
            <br/>
            <div v-for="item in relationItems.slice(Math.ceil(relationItems.length / 2), relationItems.length)" @click="changeProduct(item)"
                 class="badge dis-i pos-r"
                 :class="[imgStyle ? 'badge-img' : 'badge-img-list', chooseId === item.itemId ? 'active' : '']"
                 :style="{margin: imgStyle ? '0 4px 12px' : '0 6px 12px'}"
                 style="min-width:20%;width: 100px;vertical-align: top">
                <img class="img-sku" :src="item.imageUrl" alt="" width="100">
                <img v-if="imgStyle" @click.stop="relationImgClick(item.imageUrl)"
                     src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-img-click.png"
                     width="20" class="pos-a left0 top0" alt="">
                <span class="dis-b paddingv10 fs-14 text-limit3"
                      style="line-height: 20px;margin: 4px 6px;min-height: 24px" v-text="item.shortName"></span>
            </div>
        </div>
        <div class="row container margint30" style="padding: 0" v-show="!(relationItems.length > 4 && imgStyle)">
            <div v-for="item in relationItems" @click="changeProduct(item)"
                 class="badge dis-i pos-r"
                 :class="[imgStyle ? 'badge-img' : 'badge-img-list', chooseId === item.itemId ? 'active' : '']"
                 :style="{margin: imgStyle ? '0 4px 12px' : '0 6px 12px'}"
                 style="min-width:20%;vertical-align: top">
                <img class="img-sku" :src="item.imageUrl" alt="" width="112">
                <img v-if="imgStyle" @click.stop="relationImgClick(item.imageUrl)"
                     src="//image1.51tiangou.com/tgou2/img2/product/icon-sku-img-click.png"
                     width="20" class="pos-a left0 top0" alt="">
                <span class="dis-b paddingv10 fs-14 text-limit3"
                      :class="imgStyle ? 'text-limit3' : ''"
                      :style="{margin: imgStyle ? '4px 6' : '0', 'line-height': imgStyle ? '20px' : '1'}"
                      style="min-height: 24px" v-text="item.shortName"></span>
            </div>
        </div>
    </div>
	<div class="paddingt30 paddingb10 flex-container between" v-if="num"
         style="padding-left: 12px;padding-right: 12px">
		<span class="fs-16" style="white-space: nowrap">数量</span>
		<div class="flex-container right">
            <div class="text-light fs-12" v-if="saleMaxText" v-html="saleMaxText" style="margin-right: 8px"></div>
			<div class="col6 row container" style="min-width: 96px">
				<cmui-number :start="startNum" :min="min" :max="max" class="num-choose" v-if="isChange"></cmui-number>
			</div>
		</div>
	</div>
</div>
</template>
<style lang="scss">
.sku .row .badge.badge-img {
    padding: 0;
    border: none;
    border-radius: 4px;
    background: #f7f7f7;
    font-size: 14px;
    line-height: 36px;
    color: #000;
    overflow: hidden;
}
.sku .row .badge.badge-text {
    background: #f7f7f7;
    border-radius: 4px;
    color: #000;
}
.sku .row .badge.badge-img.active,
.sku .row .badge.badge-img-list.active{
    border: 1px solid #ff2238;
    color: #ff2238;
    background: #fff4f4;
}
.sku .row .badge.badge-img span {
    padding: 0;
}
.sku .row .badge.badge-img-list {
    padding-left: 0;
    padding-right: 12px;
    border-radius: 34px;
    background: #f7f7f7;
    color: #000;
}
.sku .row .badge.badge-img-list .img-sku {
    margin-right: 8px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    border: 1px solid #d3d3d3;
}
.sku .row .badge.badge-img-list span {
    display: inline-block;
}
.num-choose.cmui-number.form .inputGroup input {
    height: 24px;
    padding: 0 10px;
}
.num-choose.cmui-number.form .inputGroup .input_addon {
    line-height: 22px;
    width: 24px;
    min-width: 24px;
    height: 24px;
}
</style>
<script>
export default {
    name: 'tg-relation-sku',
	props: {
		sku: {
			type: Object
			, default: {
				items: []
			}
		}
		, num: {
			type: Boolean
			, default: true
		}
		, showStatus: {
			type: Boolean
			, default: false
		}
		, limit: {
			type: Number
			, default: 0
		}
		, priceLimit: {
			type: Number
			, default: 0
		},
        relationItems: {
            type: Array,
            default: []
        },
        itemId: {
            type: Number,
            default: 0
        },
        fromPage: {
            type: String,
            default: ''
        },
        start: {
            type:Number,
            default: 1
        }
	},
    data(){
        return {
            complete: false
            , tags: []
            , min: 1
            , startNum: this.start
            , max: 999
            , maxNum: 999
            , chooseId: this.itemId	// 当前已选择
            , isAll: false,
            // sku图片样式，列表false or大图true
            imgStyle: true,
            isChange: true
        };
	},
    computed: {
		saleMaxText(){
			let rs = '';
			if( this.limit && this.chooseId ){
				rs = '当前限购'+ this.limit +'件'
			}
			return rs;
		}
	}
	, watch: {
		limit(newVal){
			if( newVal ){	// 限购数量
				this.max = Math.min(this.maxNum, newVal);
			}
			else{
				this.max = this.maxNum;
			}

			if( this.priceLimit ){	// 基于价格的限购数量
				this.max = Math.min(this.max, this.priceLimit );
			}
		}
		, priceLimit(newValue){
			if( this.limit ){	// 限购数量
				this.max = Math.min(this.maxNum, this.limit);
			}
			else{
				this.max = this.maxNum;
			}

			if( newValue ){	// 基于价格的限购数量
				this.max = Math.min(this.max, newValue );
			}
		},
        sku(newValue, oldValue){
            if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
                return;
            }
            let items
                , tags
                , choose = {}
                , isAll = true;

            if( newValue && newValue.items && newValue.items.length ){
                items = newValue.items;
                tags = 'skuAttrMap' in items[0] ? Object.keys( items[0].skuAttrMap ) : [];

                this.$set('tags', tags);

                // 过滤符合已选中条件的数据
                items = items.filter(d=>{
                    let rs = tags.reduce((is, t)=>{
                        if( t in choose ){
                            is = is && (d.skuAttrMap[t] === choose[t]);
                        }
                        return is;
                    }, true);
                    if( rs ){
                        if( !choose.items ){
                            choose.items = [];
                        }
                        choose.items.push( d );
                    }
                    return rs;
                });
                this.$set('choose', choose);
                this.start = 1;
                isAll = this.tags.reduce((is, d)=>{
                    return is && (d in choose);
                }, isAll);
                this.isAll = isAll;
                if( isAll && choose.items && choose.items.length === 1 ){
                    this.maxNum = choose.items[0].realRemain === -1 ? 999 : choose.items[0].realRemain;
                    this.$dispatch('skuComplete', this.tags, choose.items[0].id, 1, choose.items[0]);
                    // todo
                } else{
                    this.maxNum = 1;
                    this.$dispatch('skuComplete', this.tags );
                }

                if( this.limit ){	// 限购数量
                    this.max = Math.min(this.maxNum, this.limit);
                } else{
                    this.max = this.maxNum;
                }
                if( this.priceLimit ){	// 基于价格的限购数量
                    this.max = Math.min(this.max, this.priceLimit );
                }
            } else{
                this.$set('choose', {});
                this.$set('tags', []);
                this.$set('isAll', false);
            }

            if( this.choose.items && this.choose.items.length === 1 ){
                this.$dispatch('skuComplete', this.tags, this.choose.items[0].id, this.start, this.choose.items[0], choose);
            } else{
                this.$dispatch('skuComplete', this.tags, '', this.start, null, choose);
            }
        }
	},
    methods: {
		emptyFunc(){},
        relationImgClick(imgUrl){
            this.$dispatch('relationImgClick', imgUrl);
        },
        changeProduct(item) {
            if (this.chooseId !== item.itemId) {
                this.isChange = false;
                this.chooseId = item.itemId;
                this.$dispatch('changeRelation', item.itemId);
                this.$nextTick(() => {
                    this.isChange = true;
                })
            }
        },
        setNum(num) {
            this.$nextTick(() => {
                this.start = num;
            })
        }
	},
    events: {
		numChange(target, num){
            this.start = num;
            if (this.sku && (num < (this.sku.items[0].realRemain === -1 ? 999 : this.sku.items[0].realRemain))) {
                this.$dispatch('changeRelation', this.chooseId, num);
            }
		},
        refreshMaxNum(){
		}
	}
};
</script>